(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Instagram-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("insta-carousel-wrapper");
  const outer = document.getElementById("insta-carousel-outer");

  let scrollStep = 208; // 200px width + 8px gap
  let autoScroll;

  function startAutoScroll() {
    autoScroll = setInterval(() => {
      if (outer.scrollLeft + outer.offsetWidth >= wrapper.scrollWidth) {
        outer.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        outer.scrollBy({ left: scrollStep, behavior: 'smooth' });
      }
    }, 3000);
  }

  function stopAutoScroll() {
    clearInterval(autoScroll);
  }

  if (window.innerWidth <= 768) {
    startAutoScroll();

    // Optional: stop on hover
    outer.addEventListener("mouseenter", stopAutoScroll);
    outer.addEventListener("mouseleave", startAutoScroll);
  }
});

  } catch(e) { console.error(e); }
})();
})();
